<ep-view>
<div>
  <div class="ep-pad-horz-5">
    <ep-text-box [value]="model.headerValue.Name"
     [readonly]="!model.canEditName"  [labelText]="'Header Name'" ></ep-text-box>
  </div>

  <div *ngIf="shouldShowTextBox()" class="ep-pad-horz-5">
    <ep-text-box [(ngModel)]="model.headerValue.Value" [labelText]="'Header Value'" ></ep-text-box>
  </div>
  <div *ngIf="shouldShowCallSettings()" class="ep-pad-horz-5">
    <ep-text-box [(ngModel)]="model.headerValue.Value.Company" [labelText]="'Company'" ></ep-text-box>
    <ep-text-box [(ngModel)]="model.headerValue.Value.Plant" [labelText]="'Plant/Site'" ></ep-text-box>
    <ep-text-box [(ngModel)]="model.headerValue.Value.Language" [labelText]="'Language'" ></ep-text-box>
    <ep-text-box [(ngModel)]="model.headerValue.Value.FormatCulture" [labelText]="'Format Culture'" ></ep-text-box>
    <ep-numeric-box [(ngModel)]="model.headerValue.Value.TimezoneOffset" [labelText]="'TimeZone Offset'"
    [min]="-14" [max]="14" [spinners]="true" [decimals]="0"
    ></ep-numeric-box>
  </div>

  <div *ngIf="shouldShowLicense()" class="ep-pad-horz-5">
    <ep-text-box [(ngModel)]="model.headerValue.Value.ClaimedLicense" [labelText]="'Claimed License'" ></ep-text-box>
    <ep-text-box [(ngModel)]="model.headerValue.Value.SessionID" [labelText]="'Session ID'" ></ep-text-box>
  </div>

  <div *ngIf="shouldShowSessionInfo()" class="ep-pad-horz-5">
    <ep-text-box [(ngModel)]="model.headerValue.Value.SessionID" [labelText]="'Session ID'" ></ep-text-box>
  </div>

  <div *ngIf="shouldShowCallInfo()" class="ep-pad-horz-5">
    <ep-text-box [(ngModel)]="model.headerValue.Value.CorrelationID" [labelText]="'Correlation ID'" ></ep-text-box>
  </div>

  <div *ngIf="shouldShowAuthorization()" class="ep-pad-horz-5">
    <div class="ep-pad-all-20">{{appStrings.authHeaderDescr}}</div>

    <ep-radio-button
      name="RadioButtonsVertical"
      [data]="radioBtnAuthorizationHeader"
      [verticalAlign]="true"
      [(ngModel)]="model.headerValue.Value.ProcessingType"
    ></ep-radio-button>
    <div *ngIf="shouldShowBasicAuth()" class="ep-pad-top-20">
      <ep-text-box  [labelText]="appStrings.authHeaderUsername"   [(ngModel)]="model.headerValue.Value.UserName" ></ep-text-box>
      <ep-text-box  [labelText]="appStrings.authHeaderPassword" [type]="'password'" [(ngModel)]="model.headerValue.Value.Password"></ep-text-box>
    </div>
    <div  *ngIf="shouldShowAuthHeaderValue()"  class="ep-pad-top-20">
      <ep-text-area   [labelText]="appStrings.authHeaderValueLabel"
                      maxLength="1024"
                      rows="4" cols="20"
                      [(ngModel)]="model.headerValue.Value.Value"
      ></ep-text-area >
    </div>
  </div>

  <div class="ep-align-hright">
    <ep-button labelText="Set" (epOnClick)="returnHeader()"></ep-button>
  </div>
</div>
</ep-view>
